import React from 'react'
import DirectoryProvider from './state/DirectoryProvider'
import DirectoryFilters from './DirectoryFilters'
import DirectoryMap from './DirectoryMap'
import DirectoryList from './DirectoryList'
import styled from 'styled-components'

const Assets = styled.div`
  padding: 20px 0;

  @media screen and (min-width: 500px) {
    padding: 50px 0;
  }

  @media screen and (min-width: 960px) {
    display: flex;
  }
`

const Directory = (props) => {
  return (
    <DirectoryProvider>
      <DirectoryFilters type={props.type} />

      <Assets>
        <DirectoryMap type={props.type} />
        <DirectoryList type={props.type} />
      </Assets>
    </DirectoryProvider>
  )
}

export default Directory
